import { sortableEntitySchema } from './sortable-entity.js';
import { namedObjectSchema, requiredNamedObjectSchema } from './named-object.js';
import { activeIngredientSchema } from './active-ingredient.js';
import { StudyEntityType } from './study-entity-type.js';
import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
import { nullishToEmptyArray } from '../utils/nullishToEmptyArray.js';
/**
 * NOTE: do not change freely, must match the values in db
 */
export var InterventionType;
(function (InterventionType) {
    InterventionType["drug"] = "drug";
    InterventionType["biologic"] = "biologic";
})(InterventionType || (InterventionType = {}));
export const interventionPackagingAndLabelingMaxLength = 1000;
export const interventionRouteOfAdministrationMaxLength = 60;
export const interventionSourcingMaxLength = 60;
export const interventionAliasMaxLength = 250;
export const interventionSchema = z.object({
    ...sortableEntitySchema.shape,
    entityType: z.literal(StudyEntityType.Intervention).default(StudyEntityType.Intervention),
    interventionType: z.enum(InterventionType).nullish().transform(nullishToUndefined).optional(),
    doseFormulation: requiredNamedObjectSchema.nullish().transform(nullishToUndefined).optional(),
    isInvestigational: z.boolean().nullish().transform(nullishToUndefined).optional(),
    manufacturer: namedObjectSchema.nullish().transform(nullishToUndefined).optional(),
    packagingAndLabeling: z
        .string()
        .max(interventionPackagingAndLabelingMaxLength)
        .nullish()
        .transform(nullishToUndefined)
        .optional(),
    routeOfAdministration: z
        .object({
        ...namedObjectSchema.shape,
        name: z.string().max(interventionRouteOfAdministrationMaxLength),
    })
        .nullish()
        .transform(nullishToUndefined)
        .optional(),
    sourcing: z
        .object({
        ...namedObjectSchema.shape,
        name: z.string().max(interventionSourcingMaxLength),
    })
        .nullish()
        .transform(nullishToUndefined)
        .optional(),
    ingredients: z.array(activeIngredientSchema).nullish().transform(nullishToEmptyArray),
    alias: z.string().max(interventionAliasMaxLength).nullish().transform(nullishToUndefined).optional(),
});
export function toIntervention(intervention) {
    const result = interventionSchema.safeParse(intervention);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid Intervention object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=intervention.js.map